<template>
    <div class="pdetail-img-box">
        <!-- 中图片 -->
        <div class="pdetail-img-md">
            <img v-lazy="mdImg" alt="">
            <!-- 放大镜 -->
            <div v-if="showMask" class="mask" :style="{left:left+'px',top:top+'px'}"></div>
            <div class="smask"
                @mouseenter="handleMask(true)"
                @mouseleave="handleMask(false)"
                @mousemove="handleMove">
            </div>
        </div>
        <!-- 大图片 -->
        <div 
            v-if="showMask"
            class="pdetail-img-lg">
            <div :style="{
                    top: -2*top+'px',
                    left: -2*left+'px ',
                }" >
                <img v-lazy="mdImg" alt="">
            </div>
        </div>
        <!-- 小图片列表 -->
        <div class="pdetail-img-sm-box clearfix">
            <!-- 左右按钮 -->
            <a href="javascript:;"
                :class="['pdetail-img-sm-btn-prev', {disable: list_left == 0}]"
                @click="handlePrev">
                <i class="glyphicon glyphicon-chevron-left"></i>
            </a>
            <a href="javascript:;"
                :class="['pdetail-img-sm-btn-next', {disable: list_left + list_width <= 350}]"
                @click="handleNext">
                <i class="glyphicon glyphicon-chevron-right"></i>
            </a>
            <!-- 小图片列表 -->
            <div class="pdetail-img-sm-list-box">
                <ul class="pdetail-img-sm-list"
                    :style="{width:list_width+'px', left:list_left+'px'}">
                    <li v-for="(item,index) in goods.goods_images"
                        :key="index"
                        :class="{select:item===mdImg}">
                        <img-pdetail-list
                            :src="item"
                            :handle-change="(src) => handleChange(src)">
                        </img-pdetail-list>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
    data() {
        return {
            showMask: false,
            top: "",
            left: "",
            list_left: 0,
        }
    },
    computed: mapState({
        goods: state => state.goods.goods,
        mdImg: state => state.goods.mdImg,
        list_width(){
            if(this.goods.goods_images && this.goods.goods_images.length){
                return this.goods.goods_images.length*80;
            }else{
                return 0
            }
        }
    }),
    components: {
        imgPdetailList: () => import("@/components/imgPdetailList")
    },
    methods: {
        ...mapMutations([
            "setMdimg",
        ]),
        // 放大镜处理函数
        handleMask(val){
            this.showMask = val;
        },
        // 放大镜移动函数
        handleMove(e){
            const MSIZE = 200, SMSIZE = 400, MAX = SMSIZE - MSIZE;
            let left = e.offsetX - MSIZE / 2;
            let top = e.offsetY - MSIZE / 2;
            // 判定是否超出图片框
            if (left < 0) left = 0; else if (left > MAX) left = MAX;
            if (top < 0) top = 0; else if (top > MAX) top = MAX;
            this.left=left;
            this.top=top;
        },

        // 上一个按钮
        handlePrev(){
            let lf = this.list_left;
            if(lf < 0){
                lf += 80;
            }
            this.list_left = lf;
        },
        // 下一个按钮
        handleNext(){
            let lf = this.list_left, wt = this.list_width;
            if(lf + wt >=350){
                lf -= 80;
            }
            this.list_left = lf;
        },
        // 切换图片
        handleChange(src){
            this.setMdimg(src)
        }
    },
}
</script>

<style scoped>
/* 组件盒子 */
.pdetail-img-box{
    position: relative;
}
/* 中图片 */
.pdetail-img-md{
    position: relative;
    width: 400px;
    height: 400px;
}
.pdetail-img-md>img{
    position: absolute;
    max-width: 100%;
    max-height: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
}
/* 放大镜样式 */
.pdetail-img-md>.mask{
    position: absolute;
    top: 0;
    left: 0;
    width: 200px;
    height: 200px;
    background-color: #ffa;
    opacity: 0.5;
}
.pdetail-img-md>.smask{
    position: absolute;
    top: 0;
    left: 0;
    opacity: 1;
    width: 400px;
    height: 400px;
    cursor: move;
    border: 1px solid #ddd;
}

/* 大图片 */
.pdetail-img-lg{
    position: absolute;
    top: 0;
    left: 480px;
    width: 400px;
    height: 400px;
    background: #fff;
    border: 1px solid #ddd;
    z-index: 500;
    overflow: hidden;
}
.pdetail-img-lg>div{
    position: absolute;
    top: 0;
    left: 0;
    width: 800px;
    height: 800px;
}
.pdetail-img-lg>div>img{
    position: absolute;
    max-width: 100%;
    max-height: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
}

/* 小图片列表盒子 */
.pdetail-img-sm-box{
    width: 400px;
    margin-top: 15px;
}
/* 左右按钮 */
.pdetail-img-sm-box>a{
    display: inline-block;
    vertical-align: middle;
    width: 18px;
    height: 70px;
    line-height: 70px;
    text-align: center;
    background-color: #909399;
    border: 1px solid transparent;
    border-radius: 2px;
}
/* 上一个按钮 */
.pdetail-img-sm-btn-prev{
    float: left;
}
/* 下一个按钮 */
.pdetail-img-sm-btn-next{
    float: right;
}
/* 图标颜色 */
.pdetail-img-sm-box>a>i{
    font-size: 12px;
    color: #fff;
}
/* 禁用按钮样式 */
.pdetail-img-sm-box>a.disable{
    background: #eee;
    cursor: not-allowed;
}
.pdetail-img-sm-box>a.disable>i{
    color: #ccc;
}
/* 小图片列表盒子 */
.pdetail-img-sm-list-box{
    position: relative;
    height: 70px;
    margin: 0 25px;
    overflow: hidden;
}
/* 图片列表 */
.pdetail-img-sm-list{
    position: absolute;
    top: 0;
    left: 0;
    transition: all linear .5s;
}
.pdetail-img-sm-list>li{
    float: left;
    width: 70px;
    height: 70px;
    border: 1px solid #e0e0e0;
    border-radius: 2px;
    margin-right:10px;
}
/* 选中的样式 */
.pdetail-img-sm-list>li.select{
    border-color: #ff6700;
}
</style>
